import { Progress } from './ui/progress';
import { useLanguage } from '@/i18n/LanguageContext';
import { useTrialData } from '@/hooks/useTrialData';

const TrialProgress = () => {
  const { remainingRequests, isSubscribed, loading, requestsUsed } = useTrialData();
  const { t } = useLanguage();

  if (loading || isSubscribed) return null;

  const progressPercent = (requestsUsed / 10) * 100;

  return (
    <div className="bg-card border rounded-lg p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium">{t('trial.progress')}</span>
        <span className="text-sm text-muted-foreground">{remainingRequests} {t('trial.requestsLeft')}</span>
      </div>
      <Progress value={progressPercent} className="h-2" />
      {remainingRequests === 0 && <p className="text-xs text-destructive mt-2">{t('trial.limitReached')}</p>}
    </div>
  );
};

export default TrialProgress;
